import { MANAGE_WORKGROUP_ACTION_TYPES } from '../../constants/actionTypes/manageWorkgroupTypes';

interface IAction {
    type: string;
    payload?: any;
}

export const INITIAL_STATE = {
    workGroupList: [],
    workGroupNames: [],
    allTags: [],
    searchAllList: [],
    submitWorkgroupListMsg: { message: '', responseStatus: ''},
};

export default (state = INITIAL_STATE, action: IAction) => {
    switch (action?.type) {
        case MANAGE_WORKGROUP_ACTION_TYPES.SET_WORKGROUP_LIST: {
            return {
                ...state,
                workGroupList: action.payload,
            };
        }
        case MANAGE_WORKGROUP_ACTION_TYPES.SET_WORKGROUP_NAMES: {
            return {
                ...state,
                workGroupNames: action.payload,
            };
        }
        case MANAGE_WORKGROUP_ACTION_TYPES.SET_WORKGROUP_ALL_TAGS: {
            return {
                ...state,
                allTags: action.payload,
            };
        }
        case MANAGE_WORKGROUP_ACTION_TYPES.SET_WORKGROUP_SUBMIT_MSG: {
            return {
                ...state,
                submitWorkgroupListMsg: action.payload,
            };
        }
        default:
            return state;
    }
};
